import generate from 'nanoid/generate';
import Runtime from '@newspaces/zero-base/Runtime';
import ZeroOrganisation from '@newspaces/zero-base/models/Organisation';
import Model from '@newspaces/zero-base/Model';
import baseUtils from '@newspaces/zero-base/utils';

class Organisation extends ZeroOrganisation {
  static Fields = {
    uniqueSlug: {
      type: String,
      required: true,
      default: () => generate("abcdefghijklmnopqrstuvwxyz0123456789", 20),
      serialize: "insert",
      description: "Used to uniquely identify the url and mail for the organisation"
    },
    country: {
      type: String,
      enum: baseUtils.countries.codes,
      description: "The country of the organisation"
    }
  };
  constructor(data) {
    super(Organisation.Fields, data);
  }
  get logoUrl() {
    if (!this.avatar || !this.avatar.path) {
      return "";
    }
    return Runtime.getStorageUrl(this.avatar.path);
  }
  // eslint-disable-next-line class-methods-use-this
  getMergeTagProperties() {
    return {
      name: { key: "name" },
      logo: { key: "logoUrl" }
    };
  }
}
Model.declareModel(Organisation);

export { Organisation as default };
//# sourceMappingURL=Organisation.js.map
